/* Rotating announcement bar.
   The current message slides up and fades out while the next rises from below. */
(function () {
  function init(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.announcement__item'));
    if (items.length < 2) {
      root.classList.add('announcement--static');
      return;
    }

    var interval = parseInt(root.dataset.interval, 10) || 3800;
    var index = 0;
    var timer = null;

    items.forEach(function (el, i) {
      el.classList.toggle('is-current', i === 0);
      el.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });

    function advance() {
      var current = items[index];
      index = (index + 1) % items.length;
      var next = items[index];

      current.classList.remove('is-current');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');

      next.classList.remove('is-leaving');
      next.classList.add('is-current');
      next.setAttribute('aria-hidden', 'false');

      // Park the outgoing message below again once its transition is done,
      // so it rises rather than drops on its next turn.
      window.setTimeout(function () { current.classList.remove('is-leaving'); }, 650);
    }

    function start() { stop(); timer = window.setInterval(advance, interval); }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }

    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    root._stopAnnouncement = stop;
  }

  document.querySelectorAll('[data-announcement]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-announcement]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-announcement]').forEach(function (root) {
      if (root._stopAnnouncement) root._stopAnnouncement();
    });
  });
})();
